module.exports = __webpack_public_path__ + "static/fonction1-7ce2bef2066003ebc63d849f274cff15.jpg";